import * as PIXI from 'pixi.js';
import { default as CanvasLayer } from '__common/vendor/canvasLayer';
/* tslint:disable */

export default class PixiLayer {
    map: google.maps.Map;
    options: any;
    renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer;
    stage: PIXI.Container;
    canvasLayer: any;
    prevHeight: number;
    prevWidth: number;
    ratio: number;

    constructor(map, options = {}) {
        this.map = map;

        this.options = {
            animate: true,
            resolutionScale: 1,
            interactive: true,
            paneName: 'overlayMouseTarget',
            transparent: true,
            antialias: true,
            resolution: 1,
            ...options,
        }

        function updateHandler() {
            // var mapProjection = this.map.getProjection();
            // var scale = Math.pow(2, this.map.zoom) * pixiLayer.options.resolutionScale;
            // var offset = mapProjection.fromLatLngToPoint(this.getTopLeft());

            // pixiLayer.stage.position.x = -offset.x * scale;
            // pixiLayer.stage.position.y = -offset.y * scale;

            // pixiLayer.stage.scale.x = scale;
            // pixiLayer.stage.scale.y = scale;

            pixiLayer.renderer.render(pixiLayer.stage);
        }

        function resizeHandler() {
            if (this.canvas && pixiLayer.renderer.screen) {
                pixiLayer.stage.hitArea = new PIXI.Rectangle(0, 0, this.canvas.width, this.canvas.height);
                pixiLayer.renderer.resize(this.canvas.width, this.canvas.height);
            }
        }


        const pixiLayer = this;
        updateHandler.bind(pixiLayer);
        resizeHandler.bind(pixiLayer);

        this.canvasLayer = new CanvasLayer({
            map: map,
            animate: this.options.animate,
            resolutionScale: this.options.resolutionScale,
            paneName: this.options.paneName,
            resizeHandler: resizeHandler,
            updateHandler: updateHandler,
        });

        this.renderer = new PIXI.CanvasRenderer(this.canvasLayer.canvas.width, this.canvasLayer.canvas.height, {
            view: this.canvasLayer.canvas,
            ...options,
            antialias: true,
        });

        this.stage = new PIXI.Container();
        this.stage.interactive = true;
        this.stage.hitArea = new PIXI.Rectangle(0, 0, this.canvasLayer.canvas.width, this.canvasLayer.canvas.height);
        this.stage.interactiveChildren = true;
        this.prevHeight;
        this.prevWidth;
        this.ratio;

        this.renderer.render(this.stage);
    }

    addLayer = (drawFunction) => {
        var layer = new PIXI.Container();
        layer.interactive = this.options.interactive || false;
        let mapProjection = this.map.getProjection();
        drawFunction(layer, mapProjection);
        this.stage.addChild(layer);
        this.renderer.render(this.stage);
    }

    getProjection = () => {
        return this.map.getProjection();
    }

    getContainer = () => {
        return this.stage;
    }

    getRenderer = () => {
        return this.renderer;
    }

    clear = () => {
        for (let i = this.stage.children.length - 1; i >= 0; i--) {
            this.stage.removeChild(this.stage.children[i]);
        }
        this.rerender();
    }

    setMap = (map) => {
        this.map = map;
    }

    rerender = () => {
        this.renderer.render(this.stage);
    }
    
    fromPixelToLatLng(pixel) {
        var scale = Math.pow(2, this.map.getZoom());
        var proj = this.map.getProjection();
        var bounds = this.map.getBounds();
      
        var nw = proj.fromLatLngToPoint(
          new google.maps.LatLng(
            bounds.getNorthEast().lat(),
            bounds.getSouthWest().lng()
          ));
        var point = new google.maps.Point(0, 0);
      
        point.x = pixel.x / scale * this.options.resolutionScale + nw.x;
        point.y = pixel.y / scale * this.options.resolutionScale + nw.y;
      
        return proj.fromPointToLatLng(point);
      }

    fromLatLngToPixel(latLng) {
        var scale = Math.pow(2, this.map.getZoom());
        var proj = this.map.getProjection();
        var bounds = this.map.getBounds();

        var nw = proj.fromLatLngToPoint(
          new google.maps.LatLng(
            bounds.getNorthEast().lat(),
            bounds.getSouthWest().lng()
          ));

        var worldPoint = proj.fromLatLngToPoint(
          new google.maps.LatLng(latLng.lat, latLng.lng)
        );

        return {
          x: (worldPoint.x - nw.x) * scale / this.options.resolutionScale,
          y: (worldPoint.y - nw.y) * scale / this.options.resolutionScale,
        };
      }

      destroy() {
          this.renderer = null;
          this.stage = null;
          this.canvasLayer.removeListeners();
      }
}